import { MultiPoint, Point } from 'ol/geom';

import getPointStyle from './pointStyle';

/**
 * @private
 * Get an OL point style instance for a line feature according to a symbolizer.
 * The style will render a point on the middle of the line.
 * @param {object} symbolizer SLD symbolizer object.
 * @param {ol/Feature} feature OpenLayers Feature.
 * @returns {ol/Style} OpenLayers style instance.
 */
function getPolygonPointStyle(symbolizer, feature) {
  const geom = feature.getGeometry();
  if (!geom) {
    return null;
  }

  let pointStyle = null;
  const geomType = geom.getType();
    if (geomType === 'Polygon') {
        var coordinates = [];
        feature.getGeometry().getCoordinates().forEach(coords => {
            coords.forEach(coord => {
                coordinates.push(coord);
            });
        });

        pointStyle = getPointStyle(symbolizer, feature);
        pointStyle.setGeometry(new MultiPoint(coordinates));
  } else if (geomType === 'MultiPolygon') {
    var coordinates = [];
    geom.getCoordinates().forEach(polygonCoords => {
        polygonCoords.forEach(ringCoords => {
            ringCoords.forEach(coord => {
                coordinates.push(coord);
            });
        });
    });

    pointStyle = getPointStyle(symbolizer, feature);
    pointStyle.setGeometry(new MultiPoint(coordinates));
  }

  return pointStyle;
}

export default getPolygonPointStyle;
